module.exports = __webpack_public_path__ + "d8f5da63fff635126d5665c0694045b2.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/brand_ambassadors/modern_marketer_iphone_mobile.png
// module id = 561
// module chunks = 0